import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader/index";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { dateConvert } from "../../../../helpers/dateConvert";
import "../../../../_metronic/_assets/plugins/flaticon2/flaticon.css";
import { FaKey } from 'react-icons/fa';
import { HiDocumentText } from 'react-icons/hi';
import { FaPercent } from "react-icons/fa"
import { FaCalendarAlt } from "react-icons/fa"
import { ImListNumbered } from "react-icons/im"
import { GoLink } from "react-icons/go";
import { FaExternalLinkAlt } from "react-icons/fa";

const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
});

export default function View(props) {
  const { onClose, campaign } = props;
  const {
    partnerId,
    partnerName,
    nameAz,
    discountPercent,
    link,
    expireDate,
    order
  } = campaign;
  const classes = useStyles();
  const sideList = (side) => (
    <div className={classes.list} role="presentation">
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="h3 mb-0">Campaign details</h1>
        <CloseIcon className={classes.pointer} onClick={onClose} />
      </div>
      <Divider className="bg-dark" />
      <div className="drawer-body">
        <Card className={classes.card}>
          <CardHeader
            title="General information"
            className="bg-secondary text-dark h6 p-3"
            disableTypography
          />

          <CardHeader

            avatar={

              <FaKey className="icon-primary icon" />
            }

            title={partnerId}
            subheader="Partner Id"
            className="p-3"
          />
          <CardHeader
            avatar={
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/Address-card.svg"
                )}
                className="icon-primary"
              />
            }
            title={partnerName}
            subheader="Partner name"
            className="p-3"
          />
          <CardHeader
            avatar={

              <HiDocumentText className="icon-primary" />

            }
            title={nameAz}
            subheader="Name"
            className="p-3"
          />


          {/* <CardHeader
            avatar={

              <FaExternalLinkAlt className="icon-primary icon" />
            }
            title="Link"
            // title={`${<a href={nameAz} target="_blank">{nameAz}</a>}`}
            subheader={<a href={nameAz} target="_blank">{nameAz}</a>}
            // subheader="Link"
            className="p-3"
          /> */}
          <CardHeader
            avatar={<FaExternalLinkAlt className="icon-primary icon" />}
            title={<a href={link} target="_blank" rel="noopener noreferrer">{link || "-"}</a>}
            subheader="Link"
            className="p-3"
          />


          <CardHeader
            avatar={

              <FaPercent className="icon-primary icon" />
            }
            title={discountPercent}
            subheader="Discount percent"
            className="p-3"
          />

          <CardHeader
            avatar={

              <ImListNumbered className="icon-primary icon" />
            }
            title={order}
            subheader="Order"
            className="p-3"
          />

          <CardHeader
            avatar={
              <FaCalendarAlt className="icon-primary icon" />
            }
            title={dateConvert(expireDate)}
            subheader="Expire date"
            className="p-3"
          />
        </Card>

      </div>
    </div>
  );

  return (
    <Drawer {...props} anchor="right" className="drawer--fixed">
      {sideList("right")}
    </Drawer>
  );
}
